/**
 * ============================================================================
 * EVOLIS — module assistant IA (développement Louis, conçu pour être détachable)
 *  Le logo d'Evolis : le pingouin à l'étoile.
 *  Image bitmap affichée à la taille demandée (prop `size`), avec la même API
 *  que l'ancienne icône SVG pour rester interchangeable partout dans le module.
 * ============================================================================
 */

import React from 'react';
import pingouin from './evolis-pingouin.png';

const EvolisLogo = ({ size = 16, zoom = 1.4, style, ...props }) => (
    <img
        src={pingouin}
        width={size}
        height={size}
        alt=""
        aria-hidden="true"
        draggable="false"
        style={{
            objectFit: 'contain',
            display: 'inline-block',
            // L'image a une marge transparente : on l'agrandit pour que le
            // pingouin remplisse mieux sa case, sans changer l'encombrement.
            transform: `scale(${zoom})`,
            ...style,
        }}
        {...props}
    />
);

export default EvolisLogo;
